import React from "react";
import { ProgramContainer } from "../../entities/formTemplateDataType";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { FR_SUFFIX } from "../../entities/Constants";
import Utils from "../../utilities/Utils";
import { DialogBase, State } from "./DialogBase";

interface Props {
    programContainer: ProgramContainer
    isEng: boolean;
    dialogVisible:boolean;
    callback;
}

export class DialogForSubmitComponent extends DialogBase<Props,State>  {
    constructor(props: Props) {
        super(props);

       
    }

    generateContentString = () => {

        let htmlString = [];
        htmlString.push(
            <div  style={{width: "100%",paddingTop: "5px"}}>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_pre_script"}>Pre Script</label>
                    </div>
                    <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                        value={this.props.programContainer.SubmitPreScript} id={"tbl_pre_script"}
                        onChange={(e) => { this.props.programContainer.SubmitPreScript = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_post_script"}>Post Script</label>
                    </div>
                    <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                        value={this.props.programContainer.SubmitPostScript} id={"tbl_post_script"}
                        onChange={(e) => { this.props.programContainer.SubmitPostScript = e.target.value; this.props.callback() }} />
                    </div>
                </div>

            </div>);

        return htmlString;
    };
  
    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(<>
        {/* @ts-ignore */}
        <Dialog header={this.props.isEng ? "Submit content setting": "[FR] Submit content setting"} footer={this.renderFooter()}
            visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
            {this.generateContentString()}
        </Dialog></>);
        return html;
    }

  
    render() {
    
        return (
            <div>
                {this.generateHtmlString()}
            </div>
        );
    }
}
